import React, { useEffect, useContext } from "react";
import axios from "axios";
import {GlobalContext} from "../constants/Context";
import { logPlayCricketResponse } from "../utils/playCricketLogger";
const CompetitionsAPI = ({ leagueId, season, onDataLoaded, onError, onLoading }) => {
  const {API_TOKEN} = useContext(GlobalContext);
  useEffect(() => {
    if (!leagueId || !season) return;

    const fetchCompetitions = async () => {
      const url = `https://www.play-cricket.com/api/v2/competitions.json?&season=${season}&league_id=${leagueId}&competition_type=divisions&api_token=${API_TOKEN}`;
      try {
        onLoading(true);
        const response = await axios.get(url);
        logPlayCricketResponse({
          endpoint: "competitions",
          requestUrl: url,
          httpStatus: response.status,
          isSuccess: true,
          rawResponse: response.data,
        });
        const competitionsData = response.data.competitions || [];
        onDataLoaded(competitionsData);
        onLoading(false);
      } catch (err) {
        logPlayCricketResponse({
          endpoint: "competitions",
          requestUrl: url,
          httpStatus: err.response?.status || null,
          isSuccess: false,
          rawResponse: err.response?.data || null,
          errorMessage: err.message,
        });
        onError(err.message);
        onLoading(false);
      }
    };

    fetchCompetitions();
  }, [leagueId, season]);

  return null;
};

export default CompetitionsAPI;